import { Button, Card, CardBody, Flex } from '@chakra-ui/react'
import { organizationListContext } from 'BrokerTsLib/src/context'
import type { OrganizationUnitPagedQuery } from 'BrokerTsLib/src/dtos'
import { exportUrl, useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { useNavigate } from 'react-router-dom'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { Pagination } from '@/containers/Pagination'
import { PageWrapper } from '@/layouts/components/PageWrapper'

import { OrganizationsList } from '../../containers/organization/OrganizationList'
import { OrganizationListFilter } from '../../containers/organization/OrganizationListFilter'
import { PageToolbar } from '../../containers/PageToolbar'
import { Add, Export } from '../../icons'

const defaultPageSize = 15
export const OrganizationListPage = () => {
  const [filter, setFilter] =
    useSearchParamsStatePersistance<OrganizationUnitPagedQuery>(
      {
        name: '',
        showInvalid: false,
        showRootOnly: true,
        pageIndex: 1,
        pageSize: defaultPageSize,
      },
      [],
      ['showRootOnly'],
    )
  const navigate = useNavigate()

  const { data, isLoading: isLoading, refetch } = useGetAll(filter)
  const items = data?.data

  return (
    <PageWrapper
      header={<DashboardHeader title="Přehled organizací" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 4,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      <organizationListContext.Provider
        value={{
          loading: isLoading,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? defaultPageSize,
          filter: filter,
          setCurrentPage: (p: number) => setFilter(f => ({ ...f, pageIndex: p })),
          setPageSize: (s: number) => setFilter(f => ({ ...f, pageSize: s })),
          updateFilter: setFilter,
          reload: () => refetch(),
        }}
      >
        <PageToolbar
          rightElements={
            <Flex sx={{ gap: 4 }}>
              <Button colorScheme="gray" onClick={() => window.open(exportUrl)}>
                <Export />
                Exportovat
              </Button>

              <Button
                colorScheme="primary"
                onClick={() => navigate('/organization/create')}
              >
                <Add />
                Vytvořit novou organizaci
              </Button>
            </Flex>
          }
        />

        <Card>
          <CardBody>
            <OrganizationListFilter p={4} />
            <OrganizationsList organizations={items?.items ?? []} />
            <Pagination context={organizationListContext} />
          </CardBody>
        </Card>
      </organizationListContext.Provider>
    </PageWrapper>
  )
}
